import resetCalendar from "./methods/resetCalendar.js";
import updateCalendar from "./methods/updateCalendar.js";
import initCalendar from "./methods/initCalendar.js";
import DOMDefault from "./templates/DOMDefault.js";
import DOMMultiple from "./templates/DOMMultiple.js";
import DOMMonths from "./templates/DOMMonth.js";
import DOMYears from "./templates/DOMYear.js";
import classes from "../classes.js";
class VanillaCalendar {
  constructor(selector, option) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __, _$, _aa, _ba, _ca, _da, _ea, _fa, _ga, _ha, _ia, _ja, _ka, _la, _ma, _na, _oa, _pa, _qa, _ra, _sa, _ta;
    this.reset = () => resetCalendar(this);
    this.update = () => updateCalendar(this);
    this.init = () => initCalendar(this);
    this.HTMLElement = typeof selector === "string" ? document.querySelector(selector) : selector;
    if (!this.HTMLElement) return;
    this.input = (option == null ? void 0 : option.input) ?? false;
    this.type = (option == null ? void 0 : option.type) ?? "default";
    this.months = (option == null ? void 0 : option.months) ?? 2;
    this.date = {
      min: ((_a = option == null ? void 0 : option.date) == null ? void 0 : _a.min) ?? "1970-01-01",
      max: ((_b = option == null ? void 0 : option.date) == null ? void 0 : _b.max) ?? "2470-12-31",
      today: ((_c = option == null ? void 0 : option.date) == null ? void 0 : _c.today) ?? /* @__PURE__ */ new Date()
    };
    this.settings = {
      lang: ((_d = option == null ? void 0 : option.settings) == null ? void 0 : _d.lang) ?? "en",
      iso8601: ((_e = option == null ? void 0 : option.settings) == null ? void 0 : _e.iso8601) ?? true,
      range: {
        min: ((_g = (_f = option == null ? void 0 : option.settings) == null ? void 0 : _f.range) == null ? void 0 : _g.min) ?? this.date.min,
        max: ((_i = (_h = option == null ? void 0 : option.settings) == null ? void 0 : _h.range) == null ? void 0 : _i.max) ?? this.date.max,
        disablePast: ((_k = (_j = option == null ? void 0 : option.settings) == null ? void 0 : _j.range) == null ? void 0 : _k.disablePast) ?? false,
        disableGaps: ((_m = (_l = option == null ? void 0 : option.settings) == null ? void 0 : _l.range) == null ? void 0 : _m.disableGaps) ?? false,
        disableAllDays: ((_o = (_n = option == null ? void 0 : option.settings) == null ? void 0 : _n.range) == null ? void 0 : _o.disableAllDays) ?? false,
        disableWeekday: ((_q = (_p = option == null ? void 0 : option.settings) == null ? void 0 : _p.range) == null ? void 0 : _q.disableWeekday) ?? null,
        disabled: ((_s = (_r = option == null ? void 0 : option.settings) == null ? void 0 : _r.range) == null ? void 0 : _s.disabled) ?? null,
        enabled: ((_u = (_t = option == null ? void 0 : option.settings) == null ? void 0 : _t.range) == null ? void 0 : _u.enabled) ?? null
      },
      selection: {
        day: ((_w = (_v = option == null ? void 0 : option.settings) == null ? void 0 : _v.selection) == null ? void 0 : _w.day) ?? "single",
        month: ((_y = (_x = option == null ? void 0 : option.settings) == null ? void 0 : _x.selection) == null ? void 0 : _y.month) ?? true,
        year: ((_A = (_z = option == null ? void 0 : option.settings) == null ? void 0 : _z.selection) == null ? void 0 : _A.year) ?? true,
        time: ((_C = (_B = option == null ? void 0 : option.settings) == null ? void 0 : _B.selection) == null ? void 0 : _C.time) ?? false,
        controlTime: ((_E = (_D = option == null ? void 0 : option.settings) == null ? void 0 : _D.selection) == null ? void 0 : _E.controlTime) ?? "all",
        stepHours: ((_G = (_F = option == null ? void 0 : option.settings) == null ? void 0 : _F.selection) == null ? void 0 : _G.stepHours) ?? 1,
        stepMinutes: ((_I = (_H = option == null ? void 0 : option.settings) == null ? void 0 : _H.selection) == null ? void 0 : _I.stepMinutes) ?? 1
      },
      selected: {
        dates: ((_K = (_J = option == null ? void 0 : option.settings) == null ? void 0 : _J.selected) == null ? void 0 : _K.dates) ?? null,
        month: ((_M = (_L = option == null ? void 0 : option.settings) == null ? void 0 : _L.selected) == null ? void 0 : _M.month) ?? null,
        year: ((_O = (_N = option == null ? void 0 : option.settings) == null ? void 0 : _N.selected) == null ? void 0 : _O.year) ?? null,
        holidays: ((_Q = (_P = option == null ? void 0 : option.settings) == null ? void 0 : _P.selected) == null ? void 0 : _Q.holidays) ?? null,
        time: ((_S = (_R = option == null ? void 0 : option.settings) == null ? void 0 : _R.selected) == null ? void 0 : _S.time) ?? null
      },
      visibility: {
        theme: ((_U = (_T = option == null ? void 0 : option.settings) == null ? void 0 : _T.visibility) == null ? void 0 : _U.theme) ?? "system",
        themeDetect: ((_W = (_V = option == null ? void 0 : option.settings) == null ? void 0 : _V.visibility) == null ? void 0 : _W.themeDetect) ?? "html[data-theme]",
        monthShort: ((_Y = (_X = option == null ? void 0 : option.settings) == null ? void 0 : _X.visibility) == null ? void 0 : _Y.monthShort) ?? true,
        weekNumbers: ((__ = (_Z = option == null ? void 0 : option.settings) == null ? void 0 : _Z.visibility) == null ? void 0 : __.weekNumbers) ?? false,
        weekend: ((_aa = (_$ = option == null ? void 0 : option.settings) == null ? void 0 : _$.visibility) == null ? void 0 : _aa.weekend) ?? true,
        today: ((_ca = (_ba = option == null ? void 0 : option.settings) == null ? void 0 : _ba.visibility) == null ? void 0 : _ca.today) ?? true,
        disabled: ((_ea = (_da = option == null ? void 0 : option.settings) == null ? void 0 : _da.visibility) == null ? void 0 : _ea.disabled) ?? false,
        daysOutside: ((_ga = (_fa = option == null ? void 0 : option.settings) == null ? void 0 : _fa.visibility) == null ? void 0 : _ga.daysOutside) ?? true
      }
    };
    this.locale = {
      months: ((_ha = option == null ? void 0 : option.locale) == null ? void 0 : _ha.months) ?? [],
      weekday: ((_ia = option == null ? void 0 : option.locale) == null ? void 0 : _ia.weekday) ?? []
    };
    this.actions = {
      clickDay: ((_ja = option == null ? void 0 : option.actions) == null ? void 0 : _ja.clickDay) ?? null,
      clickWeekNumber: ((_ka = option == null ? void 0 : option.actions) == null ? void 0 : _ka.clickWeekNumber) ?? null,
      clickMonth: ((_la = option == null ? void 0 : option.actions) == null ? void 0 : _la.clickMonth) ?? null,
      clickYear: ((_ma = option == null ? void 0 : option.actions) == null ? void 0 : _ma.clickYear) ?? null,
      clickArrow: ((_na = option == null ? void 0 : option.actions) == null ? void 0 : _na.clickArrow) ?? null,
      changeTime: ((_oa = option == null ? void 0 : option.actions) == null ? void 0 : _oa.changeTime) ?? null,
      changeToInput: ((_pa = option == null ? void 0 : option.actions) == null ? void 0 : _pa.changeToInput) ?? null
    };
    this.popups = (option == null ? void 0 : option.popups) ?? null;
    this.CSSClasses = (() => {
      const classesObj = { ...classes };
      Object.keys(classes).forEach((className) => {
        var _a2;
        if ((_a2 = option == null ? void 0 : option.CSSClasses) == null ? void 0 : _a2[className]) {
          classesObj[className] = option.CSSClasses[className];
        } else {
          classesObj[className] = classes[className];
        }
      });
      return classesObj;
    })();
    this.DOMTemplates = {
      default: ((_qa = option == null ? void 0 : option.DOMTemplates) == null ? void 0 : _qa.default) ?? DOMDefault(this.CSSClasses),
      multiple: ((_ra = option == null ? void 0 : option.DOMTemplates) == null ? void 0 : _ra.multiple) ?? DOMMultiple(this.CSSClasses),
      month: ((_sa = option == null ? void 0 : option.DOMTemplates) == null ? void 0 : _sa.month) ?? DOMMonths(this.CSSClasses),
      year: ((_ta = option == null ? void 0 : option.DOMTemplates) == null ? void 0 : _ta.year) ?? DOMYears(this.CSSClasses)
    };
    this.currentType = this.type;
  }
}
export {
  VanillaCalendar as default
};
